import { render, staticRenderFns } from "./ViewCandidateProctorScreen.vue?vue&type=template&id=9034ff2c"
import script from "./ViewCandidateProctorScreen.vue?vue&type=script&lang=js"
export * from "./ViewCandidateProctorScreen.vue?vue&type=script&lang=js"
import style0 from "./ViewCandidateProctorScreen.vue?vue&type=style&index=0&id=9034ff2c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports